import React, { Component } from 'react'
import Constantes from '../php/Constantes';

class AlertasPersonal extends Component {
    constructor(props){
        super(props);
        this.state = {
            mostrarAlerta: false,
        }
    }


    async componentDidMount(){
        const cargaUtil = JSON.stringify([sessionStorage.lugar,sessionStorage.lugarCentral]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/verificar_alertasPersonal.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datos = await respuesta.json();
        if((datos) && (datos === 'si')){
            this.setState({
                mostrarAlerta: true,
            })
        }
    }

    render(){
        return (
            <>
                {this.state.mostrarAlerta ? (<div className='alert alert-danger' style={{textAlign:'center'}}> Tiene actividades pendientes </div>) : null}
            </>
        )
    }
}

export default AlertasPersonal